import { useMemo, useRef } from "react";
import { Menu } from "primereact/menu";

import { useKeycloakContext } from "../../../../keycloak";
import { Notifications } from "./Notifications/Notifications";
import { Chat } from "./Chat/Chat";
import { useUser } from "../../../../keycloak";

import styles from "./Header.module.scss";

type TUser = {
  firstName: string;
  lastName: string;
  username: string;
};

export const Header = () => {
  const keycloakContext = useKeycloakContext();

  const user = useMemo<TUser>(
    () => keycloakContext.getUserData(),
    [keycloakContext]
  );


  const userRole: any = useUser();

  const menu = useRef<any>(null);

  const items = [
    {
      label: "Logout",
      icon: "pi pi-sign-out",
      command: () => {
        keycloakContext.logout();
      },
      className: styles.menuItem,
    },
  ];

  const shouldRenderChat = userRole && userRole.role && userRole.role !== "CLIENT";
    
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.profile}>
          {
            shouldRenderChat && 
            <>
              <Chat />
              <Notifications />
            </>
          }
          <button
            className={styles.credentials}
            onClick={(event) => menu.current && menu.current.toggle(event)}
            aria-controls="popup_menu"
            aria-haspopup
          >
            <span>{user?.firstName || user?.username}</span>
            <span>{user?.lastName}</span>
            <i className="pi pi-chevron-down"></i>
          </button>
        </div>
      </div>
      <Menu
        className={styles.menu}
        model={items}
        popup
        ref={menu}
        id="popup_menu"
      />
    </div>
  );
};
